import type * as Style from '../../index.js'
import { Keyword, NumberValue } from '../../values/index.js'

export enum JustifyContent {
  'stretch' = 'stretch',
  'flex-start' = 'flex-start',
  'center' = 'center',
  'space-between' = 'space-between',
  'space-evenly' = 'space-evenly',
  'flex-end' = 'flex-end'
}

export enum AlignItems {
  'stretch' = 'stretch',
  'flex-start' = 'flex-start',
  'center' = 'center',
  'flex-end' = 'flex-end'
}

export const Props = (props: any = {}) => {
  const columnCount = props.columnCount === null ? null : NumberValue(props.columnCount) ?? 1
  var weights: number[]
  if (columnCount === null) {
    weights = []
  } else if (!props.weights || !Array.isArray(props.weights) || props.weights.length != props.columnCount) {
    weights = new Array(columnCount).fill(1)
  } else {
    weights = props.weights.map((weight: any) => {
      return NumberValue(weight) ?? 1
    })
  }

  return {
    flexWrap: !!props.flexWrap,
    columnCount,
    weights,
    justifyContent: Keyword<JustifyContent>(
      props.justifyContent,
      JustifyContent,
      columnCount == 1 ? 'flex-start' : 'stretch'
    ),
    alignItems: Keyword<AlignItems>(props.alignItems, AlignItems)
  }
}
export type Props = ReturnType<typeof Props>
export const validate = () => true
export const fix = (props: Props, styles: Style.Rule[]) => props
export const type = 'layout'
export const property = 'layoutIds'
export const label = 'Layout & Alignment'
export const category = 'aspect'
export const summarize = (props: Props, styles?: Style.Rule[], formId?: string) => `${props.columnCount ?? 'Auto'}`
